import { ReactElement } from "react";
import styles from "./HighlightedText.module.less";

export type Highlight = readonly [start: number, length: number];

export type HighlightedTextProps = {
	text: string | nil;
	highlight: Highlight | nil;
};

export const HighlightedText = (props: HighlightedTextProps): ReactElement => {
	const {
		text,
		highlight
	} = props;

	const noneNilText: string = text ?? "";

	const [start, length] = highlight ?? [noneNilText.length, 0];

	const textBefore: string = noneNilText.slice(0, start);
	const highlightedText: string = noneNilText.slice(start, start + length);
	const textAfter: string = noneNilText.slice(start + length);

	return (
		<>
			{textBefore}
			{highlightedText && (
				<mark className={styles.highlight}>
					{highlightedText}
				</mark>
			)}
			{textAfter}

		</>
	);
};
HighlightedText.displayName="HighlightedText";